"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardWidget = void 0;
var DashboardWidget;
(function (DashboardWidget) {
    DashboardWidget["CURRENCY_ACCOUNT_BALANCES"] = "CURRENCY_ACCOUNT_BALANCES";
    DashboardWidget["OUTSTANDING_ACTIONS"] = "OUTSTANDING_ACTIONS";
    DashboardWidget["LIVE_RATES"] = "LIVE_RATES";
    DashboardWidget["MTM"] = "MTM";
    DashboardWidget["FACILITIES"] = "FACILITIES";
    DashboardWidget["HEDGING_PROGRAMS"] = "HEDGING_PROGRAMS";
})(DashboardWidget = exports.DashboardWidget || (exports.DashboardWidget = {}));
